import React from 'react';
import { motion } from 'framer-motion';
import { Wrench, Car, Leaf } from 'lucide-react';
export function WhyChooseUs() {
  return <section id="why-us" className="py-24 bg-[#151515]" data-id="element-185">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-187">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center px-4" data-id="element-188">
            <div className="w-20 h-20 mx-auto bg-[#1a1a1a] rounded-full flex items-center justify-center mb-6 border border-[#c41e3a]/30 shadow-[0_0_30px_rgba(196,30,58,0.1)]" data-id="element-189">
              <Wrench className="w-10 h-10 text-[#c41e3a]" data-id="element-190" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-191">
              European Specialists
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-192">
              Factory-trained technicians with decades of experience
              specifically on European engineering and high-performance systems.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-center px-4" data-id="element-193">
            <div className="w-20 h-20 mx-auto bg-[#1a1a1a] rounded-full flex items-center justify-center mb-6 border border-[#d4af37]/30 shadow-[0_0_30px_rgba(212,175,55,0.1)]" data-id="element-194">
              <Car className="w-10 h-10 text-[#d4af37]" data-id="element-195" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-196">
              All Makes Welcome
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-197">
              From daily drivers to weekend exotics, we service all vehicles
              with the same level of expert care and attention to detail.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="text-center px-4" data-id="element-198">
            <div className="w-20 h-20 mx-auto bg-[#1a1a1a] rounded-full flex items-center justify-center mb-6 border border-green-500/30 shadow-[0_0_30px_rgba(34,197,94,0.1)]" data-id="element-199">
              <Leaf className="w-10 h-10 text-green-500" data-id="element-200" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-201">
              Eco-Friendly Practices
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-202">
              We are committed to responsible disposal and recycling of all
              fluids and parts to protect our local environment.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}